export default "__VITE_ASSET__RJTS79yi__"